import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullHeight: {
    height: "100%",
  },
}));

export default useStyles;
